import {
  Typography,
  Box,
  TableCell,
  TableRow,
  Stack,
} from '@mui/material';

import { MessageItems } from "@/types/admin_types";
import { useState } from 'react';
import MessageDetails from './MessageDetails';
import DeleteElComponent from '../../_components/DeleteElComponent';
import DialogComponent from '../../_components/DialogComponent';
import { Button } from '@/components/ui/button';
import { Eye, Trash2 } from 'lucide-react';


type Props = {
  el: MessageItems;
  index: number;
}
export default function MessageRow({ el, index }: Props) {

  const [openDelete, setOpenDelete] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  return (
    <>
      <TableRow hover key={el?.id}>
        <TableCell style={{ paddingLeft: 30, paddingRight: 30 }}>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {index + 1} 
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.title}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.email}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.phone}
              </Typography>
            </Box>
          </Stack>
        </TableCell>

        <TableCell>
          <Stack display='flex' gap={1} direction="row">
            <DialogComponent
              open={openDetails}
              setOpen={setOpenDetails}
              title='Message Details'
              subtitle='This is the message content sent by user'
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Eye
                    strokeWidth={2.2}
                    size={18}
                    className=" text-blue-400"
                  />
                </Button>
              }
              components={
                <MessageDetails el={el}/>
              }
            />

            <DialogComponent
              open={openDelete}
              setOpen={setOpenDelete}
              title='Delete File'
              subtitle='Are you sure you want to delete this file?'
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Trash2
                    strokeWidth={2.2}
                    size={18}
                    className=" text-rose-700"
                  />
                </Button>
              }
              components={
                <DeleteElComponent
                  preview={el?.title}
                  setOpen={setOpenDelete} 
                  url={`/api/v1/admin/contact-messages/${el?.id}`}
                  invalidate='messages'
                  disabled
                />
              }
            />
          </Stack>
        </TableCell>
      </TableRow>
    </>
  )
}
